import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import type {
  MenuItem,
  SimpleDropdownProps,
} from "@circle-react/components/shared/uikit/SimpleDropdown";
import { SimpleDropdown } from "@circle-react/components/shared/uikit/SimpleDropdown";

export interface FormAnimatedSelectProps extends SimpleDropdownProps {
  name: string;
  options: MenuItem[];
  rules?: RegisterOptions;
}

export const FormAnimatedSelect = ({
  name,
  options,
  rules = {},
  ...props
}: FormAnimatedSelectProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({
        field: { onChange, onBlur, value, ref, name },
      }: {
        field: {
          onChange: (value: any) => void;
          onBlur: () => void;
          value: any;
          ref: any;
          name: string;
        };
      }) => (
        <SimpleDropdown
          {...props}
          menuItems={options}
          onBlur={onBlur}
          name={name}
          ref={ref}
          value={value}
          onChange={onChange}
        />
      )}
    />
  );
};

FormAnimatedSelect.displayName = "Form.AnimatedSelect";
